
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";

import { ELNStore } from '../../store'

import { Loader } from '../../helpers/loader';
import { format, eachDayOfInterval } from 'date-fns'
import ExportCal from '../../components/ExportCal'
import { CsvBuilder } from 'filefy';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faFileExport, faPlayCircle, faSpinner, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { supabase } from '../../api'
import { ELAN_BRAND_ID, ELAN_PARTNER_BRAND_ID, penceToCurrency } from "../../helpers/utils";


export const Exports = ({match}) => {


  const range = ELNStore.useState(s => s.range);

  const fromDate = range && range.length && range[0] || new Date()
  const toDate = range && range.length && range[1] || new Date()

  const dateArray = fromDate && toDate ? eachDayOfInterval( { start: fromDate, end: toDate }) : []

  const [loading, setLoading] = useState(false)
  const [active, setActive] = useState(false)
  const [complete, setComplete] = useState(false)

  const [orders, setOrders] = useState()

  const rangeInWords = () => {
    if (!fromDate || !toDate) return 'Loading...'
    const fromStr = format(fromDate,'dd MMM yyyy')
    const toStr = format(toDate,'dd MMM yyyy')
    if (fromStr === toStr) return fromStr
    return `${fromStr} - ${toStr}`
  }

  const abort = () => {
      setActive(false)
      setComplete(false)
      setLoading(false)
  }

  const loadAll = async () => {

    if (!fromDate || !toDate) return


    setActive(true)
    setLoading(true)
    setComplete(false)

    const { data: orderList, error } = await supabase
        .from('orders')
        .select('*, orderProducts (quantity, unit_cost, products:product_id (*)), shops!inner (*,brands!inner (*))')
        .match({ voided: false, order_type: 0 })
        .gte('delivery_dt', format(new Date(fromDate), 'yyyy-MM-dd')) 
        .lte('delivery_dt', format(new Date(toDate), 'yyyy-MM-dd'))
        .order('delivery_dt', { ascending: true })
        .not('approved_at', 'is', null)
        .filter('shops.brands.id', 'in', `(${ELAN_BRAND_ID},${ELAN_PARTNER_BRAND_ID})`)
        
    setOrders(orderList)
    
    setComplete(true)
    
    setLoading(false)
    setActive(false)
  }


  useEffect(() => {
    
    setComplete(false)
    setLoading(false)
  }, [range])


  const exportCSV = () => {
    new CsvBuilder(`PW-${rangeInWords()}.csv`)
    .setColumns(headings)
    .addRows(orderTable())
    .exportFile();
  }

  const doPrint = () => {
    window.print()
  }


  const headings = ['DocNo', 'Date', 'Reference', 'Prod Code', 'Qty', 'Price', 'Value', 'VAT', 'Gross Value', 'Invoice Value', 'Inv VAT', 'Gross Inv Value', 'Acc Code']

  const orderTable = () => {

    let tbl = []


    orders.forEach((order,i) => {

        const orderTotal = order.orderProducts.reduce(function (acc, op) { return acc + (op.quantity * op.unit_cost) }, 0);

        const OP_VAT = 0
        const ORDER_VAT = 0

        const PURCHASER_CODE = `${order.shops.name.toUpperCase().split(' ').join('').substr(0,5)}${order.shops.id}`
        // calc order total

        order.orderProducts.forEach((op,j) => {

            if (op.quantity === 0) return 

            const netTotal =  penceToCurrency(op.unit_cost * op.quantity)

            tbl.push([
                order.purchase_order_num,
                order.delivery_dt.split('-').join(''),
                order.purchase_order_num,
                op.products.pid,
                op.quantity,
                penceToCurrency(op.unit_cost),
                netTotal,
                OP_VAT,
                netTotal,
                penceToCurrency(orderTotal),
                ORDER_VAT,
                penceToCurrency(orderTotal),
                PURCHASER_CODE
            ])
        })
    })

    return tbl
  }

  const drawOrderTable = () => {
      const tbl = orderTable()
      return (
          <>
          <div className='table-wrapper'>
            <table>
                <thead>
                <tr>
                    {headings.map(p => <th>{p}</th>)}
                </tr>  
                </thead>
                <tbody>

                    {tbl.map((row,i) => {

                        return (
                            <tr>
                                {row.map(r => (
                                    <td>{r}</td>
                                ))}        
                            </tr>
                        )
                    })}

                </tbody>
            </table>
          </div>
          </>
      )
  }


  return (
    <>
        
        <div className='outer'>
          <h1 className={''}>EL&amp;N APPROVED ORDERS For Delivery: {rangeInWords()}</h1>
          <div className='center'><ExportCal />
            {active && <button disabled onClick={abort}><FontAwesomeIcon icon={faSpinner} spin={true} />&nbsp;&nbsp;Processing...</button>}
            {!active && dateArray.length<=31 && <button onClick={loadAll}><FontAwesomeIcon icon={faPlayCircle} />&nbsp;&nbsp;START LOAD</button>}
            {!active && dateArray.length>31 && <button><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;31 days limit</button>}
          </div>
          <br/>
          
          {loading && <Loader />}
          {orders?.length && !active && complete && !loading ? 
          <>
            <ul className='button-list'>
              <li><button onClick={exportCSV}><FontAwesomeIcon icon={faFileExport} />&nbsp;&nbsp;Export CSV</button></li>
              <li><button onClick={doPrint}><FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;Print</button></li>
            </ul>
            {drawOrderTable()}
          </>
          : ''}
        </div>
    </>
  )
}

export default withRouter(Exports);
